import { render, staticRenderFns } from "./OrderHistoryModal.vue?vue&type=template&id=40f40b4b&"
import script from "./OrderHistoryModal.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderHistoryModal.vue"
export default component.exports